import isMobileWeb from 'ismobilejs'
import { Platform } from 'react-native'

export const isMobile = () => Platform.OS !== 'web' || isMobileWeb(window.navigator).any
